'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { TbMoodEmpty } from 'react-icons/tb'
import { capitalizeFirst } from '@/utils/capitalize'

interface Category {
    id: string
    title: string
    href: string
}

interface SidebarMenuProps {
    pathConfig?: Category[]
    onItemClick?: () => void
}

export default function NavBarMenu({ pathConfig, onItemClick }: SidebarMenuProps) {
    const pathname = usePathname()

    if (!pathConfig || pathConfig.length === 0) {
        return (
            <div className="py-16 px-4 flex flex-col items-center justify-center text-gray-500">
                <div className="flex justify-center">
                    <TbMoodEmpty size={38} />
                </div>

                <p className="text-lg mb-2 text-center">
                    Проводятся технические работы. Приносим свои извинения
                </p>
                <p className="text-sm">
                    Попробуйте зайти позднее
                </p>
            </div>
        )
    }

    return (
        <nav className="w-2xs text-gray-800 p-2">
            <ul className="space-y-1">
                {pathConfig.map((item) => {
                    const isActive = pathname === item.href

                    return (
                        <li key={item.id} className="rounded-lg">
                            <Link
                                href={item.href}
                                onClick={() => onItemClick?.()}
                                className={`menu-item block px-3 py-2 rounded-lg transition-colors ${
                                    isActive
                                        ? 'font-bold bg-gray-100'
                                        : 'hover:bg-gray-100'
                                }`}
                            >
                                {capitalizeFirst(item.title)}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </nav>
    )
}